import React, { Component } from 'react'
import { Facebook } from 'app/assets/icons'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import styled from 'styled-components'
import type { LoginForm } from 'shared/types'
import { authType, featureCodes } from 'shared/utils'
import { SocialButton } from './SocialButton'
import { colors } from 'shared/assets/styles'
import { media } from 'app/assets/styles'
import { FormattedMessage } from 'react-intl'
import { SmallText } from 'app/common/typography'
import { GoogleSignInButton } from './GoogleSignInButton'
import { FeatureToggle } from '../feature-toggle'
import { messages } from 'shared/utils/const'

const { facebook, google, lightGrey } = colors

type Props = {
    userData: ?LoginForm,
    socialConnect: (LoginForm, ?boolean, ?boolean) => void,
    fromLogin?: boolean,
    fromEcommerce?: boolean,
    redirectUrl?: string,
    navigate: string => void,
    redirectToUrlAfterLogin?: string,
    goToRedirectAndReset: (url: string) => void,
    enableNewOrderFlow?: boolean
}

class SocialConnectComponent extends Component<Props> {
    navigate = () => {
        const { navigate, redirectUrl } = this.props
        if (redirectUrl) {
            if (this.props.enableNewOrderFlow) {
                document.location.href = redirectUrl
            } else {
                redirectUrl && navigate(redirectUrl)
            }
        }
    }

    connect = async (data: LoginForm) => {
        const {
            socialConnect,
            fromEcommerce,
            fromLogin,
            redirectUrl,
            redirectToUrlAfterLogin
        } = this.props
        try {
            const result = await socialConnect(data, fromLogin, fromEcommerce)
            if (redirectToUrlAfterLogin && result === messages.OK) {
                this.props.goToRedirectAndReset(redirectToUrlAfterLogin)
                return
            }
            if (redirectUrl) {
                this.navigate()
            }
        } catch (error) {
            console.error('Error in social connect', error)
        }
    }

    responseFacebook = (response: any) => {
        if (response) {
            const { userID, email, accessToken } = response
            if (userID) {
                const data = {
                    login: email,
                    loginType: authType.FACEBOOK,
                    stayLoggedIn: true,
                    uid: userID,
                    accessToken: accessToken
                }
                this.connect(data)
            }
        }
    }

    responseGoogle = (response: any) => {
        const { profileObj } = response
        if (profileObj) {
            const { email, googleId } = profileObj
            const data = {
                login: email,
                loginType: authType.GOOGLE,
                stayLoggedIn: true,
                uid: googleId
            }
            this.connect(data)
        }
    }

    handleGoogleSignInClick = () => {}

    render() {
        return (
            <div>
                <SocialContainer>
                    <FeatureToggle feature={featureCodes.AUTHENT_FACEBOOK}>
                        <FacebookLogin
                            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                            autoLoad={false}
                            render={(renderProps: any) => (
                                <SocialButton
                                    margin
                                    handleClick={renderProps.onClick}
                                    background={facebook}
                                    labelKey="social.facebook.button"
                                    icon={<Facebook />}
                                />
                            )}
                            fields="gender, name, email, birthday"
                            callback={this.responseFacebook}
                            isMobile={false}
                        />
                    </FeatureToggle>

                    <FeatureToggle feature={featureCodes.AUTHENT_GOOGLE}>
                        <GoogleSignInButton connect={this.connect} />
                    </FeatureToggle>
                </SocialContainer>
                <FeatureToggle
                    features={[
                        featureCodes.AUTHENT_GOOGLE,
                        featureCodes.AUTHENT_FACEBOOK
                    ]}>
                    <OrContainer>
                        <Line />
                        <FormattedMessage id="or">
                            {(text: string) => (
                                <StyledText center color={lightGrey}>
                                    {text.toString().toUpperCase()}
                                </StyledText>
                            )}
                        </FormattedMessage>
                        <Line />
                    </OrContainer>
                </FeatureToggle>
            </div>
        )
    }
}

const SocialContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin: 20px 0;
    flex-wrap: wrap;
    justify-content: space-between;
    ${media.small`
        justify-content: center;
    `};
`

const OrContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

const Line = styled.div`
    width: 100px;
    height: 1px;
    background: ${lightGrey};
    margin: 10px 0;
    ${media.small`
        width: 50%;
    `};
`

const StyledText = styled(SmallText)`
    margin: 0 10px;
`

export { SocialConnectComponent }
